// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportObjects = {
	"./node_modules/sourmash/sourmash_bg.wasm": function() {
		return {
			"./sourmash_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache0["__wbindgen_object_drop_ref"](p0i32);
				},
				"__wbindgen_number_new": function(p0f64) {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache1["__wbindgen_number_new"](p0f64);
				},
				"__wbg_new_0737b8c81a08773b": function() {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache2["__wbg_new_0737b8c81a08773b"]();
				},
				"__wbg_readAsArrayBuffer_b476c29c497a135e": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache3["__wbg_readAsArrayBuffer_b476c29c497a135e"](p0i32,p1i32);
				},
				"__wbg_size_9c7e57fbd4f0f4b5": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache4["__wbg_size_9c7e57fbd4f0f4b5"](p0i32);
				},
				"__wbg_slice_0da9ca5b030b84a7": function(p0i32,p1f64,p2f64) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache5["__wbg_slice_0da9ca5b030b84a7"](p0i32,p1f64,p2f64);
				},
				"__wbg_newwithlength_66ae46612e7f0234": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache6["__wbg_newwithlength_66ae46612e7f0234"](p0i32);
				},
				"__wbg_set_d4638f722068f043": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache7["__wbg_set_d4638f722068f043"](p0i32,p1i32,p2i32);
				},
				"__wbg_new_28c511d9baebfa89": function(p0i32,p1i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache8["__wbg_new_28c511d9baebfa89"](p0i32,p1i32);
				},
				"__wbg_apply_6d0b9cd50eb480c3": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache9["__wbg_apply_6d0b9cd50eb480c3"](p0i32,p1i32,p2i32);
				},
				"__wbg_buffer_12d079cc21e14bdb": function(p0i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache10["__wbg_buffer_12d079cc21e14bdb"](p0i32);
				},
				"__wbg_new_63b92bc8671ed464": function(p0i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache11["__wbg_new_63b92bc8671ed464"](p0i32);
				},
				"__wbg_set_a47bac70306a19a7": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache12["__wbg_set_a47bac70306a19a7"](p0i32,p1i32,p2i32);
				},
				"__wbg_length_c20a40f15020d68a": function(p0i32) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache13["__wbg_length_c20a40f15020d68a"](p0i32);
				},
				"__wbg_byteLength_58f7b4fab1919d44": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache14["__wbg_byteLength_58f7b4fab1919d44"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache15["__wbindgen_debug_string"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache16["__wbindgen_throw"](p0i32,p1i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c["./node_modules/sourmash/sourmash_bg.js"].exports;
					return wasmImportedFuncCache17["__wbindgen_memory"]();
				}
			}
		};
	},
};

var wasmModuleMap = {
	"node_modules_sourmash_sourmash_js": [
		"./node_modules/sourmash/sourmash_bg.wasm"
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"node_modules_sourmash_sourmash_js":{"./node_modules/sourmash/sourmash_bg.wasm":"51c618591ae0642557c2"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};